<template>
  <div class="space-y-1">
    <label
      id="list-player-label"
      class="block text-sm leading-5 font-medium text-gray-700"
    >
      <slot name="SelectLabel"></slot>
    </label>
    <div
      class="relative w-full rounded-md border border-gray-300 bg-white outline-none pl-3 pr-3 py-2 text-left focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
    >
      <div
        class="chip"
        v-for="(player, index) in tags"
        :key="`${player.playerId}-tag`"
      >
        <!-- Replace image with Avatar -->
        <img
          src="https://picsum.photos/200"
          alt="Person"
          width="96"
          height="96"
        />
        {{ player.playerId }}
        <span class="closebtn" @click="onRemoveTag(index)">&times;</span>
      </div>
      <input
        type="text"
        @input="onChange"
        @keydown.delete="removeLastTag"
        v-model="userInput"
        placeholder="Enter a Tag"
        class="outline-none"
        ref="autocompleteInput"
      />
    </div>

    <div
      v-if="filteredSuggestions.length"
      class="absolute z-10 rounded-md border border-gray-300 bg-white outline-none"
    >
      <div
        v-for="(suggestion, index) in filteredSuggestions"
        :key="index"
        @click="handleTagSelect(suggestion)"
        class="at-option w-full px-4 py-2 border-b flex-col justify-center items-start"
      >
        <span class="">
          {{ suggestion[optionKey] }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { SetupContext } from "vue";

import useAutoComplete from "composables/useAutoComplete";
import { Player } from "types/player";

interface Props {
  options: Player[];
  optionKey: string;
  label: string;
}

export default {
  name: "AutoCompleteChip",
  props: {
    options: {
      type: Array as () => Player[],
      required: true,
      default: [],
    },
    optionKey: {
      type: String,
      required: true,
      default: "email",
    },
    label: {
      type: String,
      required: true,
      default: "label",
    },
  },
  setup(props: Props, { emit }: SetupContext) {
    // Use AutoComplete composable
    const autoCompleteComp = useAutoComplete(props.options, props.optionKey);

    // Handle Tag selection
    const handleTagSelect = (value: Player) => {
      autoCompleteComp.selected(value);
      // Emit an event
      emit("on-tags-select", { playersOrder: autoCompleteComp.tags.value });
    };

    return {
      ...autoCompleteComp,
      handleTagSelect,
    };
  },
  emits: ["on-tags-select"],
};
</script>

<style scoped>
.at-option:last-child {
  border: 0;
}

.chip {
  display: inline-block;
  padding: 0 15px;
  margin: 0.5rem;
  height: 30px;
  font-size: 15px;
  line-height: 30px;
  border-radius: 25px;
  background-color: #f1f1f1;
}

.chip:first-child {
  background-color: #f7ce04;
  border: 1px solid #f4c110;
}

.chip:nth-child(2) {
  background-color: #c9ccd1;
  border: 1px solid #b7bec4;
}

.chip:nth-child(3) {
  background-color: #eaad60;
  border: 1px solid #a26545;
}

.chip:nth-child(n + 4) {
  @apply bg-red-400;
  @apply border;
  @apply border-red-700;
}

.chip img {
  float: left;
  margin: 2px 5px 2px -20px;
  height: 25px;
  width: 25px;
  border-radius: 50%;
}

.closebtn {
  padding-left: 10px;
  color: #888;
  font-weight: bold;
  float: right;
  font-size: 20px;
  cursor: pointer;
}

.closebtn:hover {
  color: #000;
}
</style>
